import React from 'react';

const IntroTitle = (props) =>{
    const {fontSize,lineHeight,children} = props;

    var style;

    if(window.innerWidth > 1000){

      style = {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '900',
        fontSize: (fontSize || '72px'),
        lineHeight: (lineHeight || '80px'),
        textTransform: 'uppercase',
        color: '#262628',
        marginTop:'12px',
      }

    }else{

        style = {
          fontFamily: 'Montserrat',
          fontStyle: 'normal',
          fontWeight: '900',
          fontSize: (fontSize || '8.5vw'),
          lineHeight: (lineHeight || '8.8vw'),
          textTransform: 'uppercase',
          color: '#262628',
          margin: 0
        }
    }
    return <p className="intro-title" style={style}>{children}</p>;
}

export default IntroTitle;